import { FC, useContext, useEffect } from "react";
import { IFooterProps, Footer } from "../footer/index";
import { INavBarProps, NavBar } from "../navbar/index";
import styles from "./styles.module.scss";
import { IndexContext } from "@/stores";
import { useRouter } from "next/router";

export interface ILayoutProps {
  navbarData: INavBarProps;
  footerData: IFooterProps;
}

export const Layout: FC<ILayoutProps & { children: JSX.Element }> = ({
  navbarData,
  footerData,
  children,
}) => {
  const { isHeadFoot } = useContext(IndexContext);
  const router = useRouter()

  // useEffect(() => {
  //   if (router.asPath.slice(0, 3) === '/en') {
  //     setLang('en')
  //   } else {
  //     setLang('cn')
  //   }
  // }, [router])

  return (
    <div className={styles.layout} style={{ fontSize: router.locale === 'cn' ? '16px' : '20px' }}>
      {
        isHeadFoot &&
        <NavBar {...navbarData} />
      }
      <main className={styles.main}>{children}</main>
      {
        isHeadFoot &&
        <Footer {...footerData} />
      }
    </div>
  );
};
